export default __webpack_public_path__ + "static/media/Undo.b30bbbf9.svg";